import {
  BRAND_INSIGHTS_APPLY_ALREADY_IN_CONFIG,
  BRAND_INSIGHTS_APPLY_REJECTED,
  BRAND_INSIGHTS_APPLY_RETRY,
  BRAND_INSIGHTS_APPLY_REWRITE,
  BRAND_INSIGHTS_APPLY_TIMEOUT,
  BRAND_INSIGHTS_APPLY_UNMAPPABLE,
} from "../../../../i18n/keysTranslations";
import { BRAND_INSIGHT_REASON_ALREADY_IN_CONFIG } from "../../../../utils/constants";

/**
 * Server reasons collapsed to the few messages a marketer can act on.
 * unmappable + off-allowlist: insight cannot land on brand fields.
 * ai-failed + empty-edits: transient, retry.
 * timeout: the front cut, the backend deadline, or an AI timeout.
 * missing-insight and anything unknown: generic fallback.
 */
const APPLY_ERROR_MESSAGE_KEYS = {
  [BRAND_INSIGHT_REASON_ALREADY_IN_CONFIG]:
    BRAND_INSIGHTS_APPLY_ALREADY_IN_CONFIG,
  unmappable: BRAND_INSIGHTS_APPLY_UNMAPPABLE,
  "off-allowlist": BRAND_INSIGHTS_APPLY_UNMAPPABLE,
  rewrite: BRAND_INSIGHTS_APPLY_REWRITE,
  "ai-failed": BRAND_INSIGHTS_APPLY_RETRY,
  "empty-edits": BRAND_INSIGHTS_APPLY_RETRY,
  timeout: BRAND_INSIGHTS_APPLY_TIMEOUT,
};

const INFORMATIONAL_APPLY_REASONS = new Set([
  BRAND_INSIGHT_REASON_ALREADY_IN_CONFIG,
  "unmappable",
  "off-allowlist",
]);

export const getApplyErrorMessageKey = (reason) =>
  APPLY_ERROR_MESSAGE_KEYS[reason] || BRAND_INSIGHTS_APPLY_REJECTED;

export const isInformationalApplyError = (reason) =>
  INFORMATIONAL_APPLY_REASONS.has(reason);

const RETRYABLE_APPLY_REASONS = new Set([
  "timeout",
  "ai-failed",
  "empty-edits",
  "rewrite",
  "rejected",
  "confirm-failed",
]);

export const isRetryableApplyError = (reason) =>
  RETRYABLE_APPLY_REASONS.has(reason);
